import { initializeAllCollapsibles } from "./collapsible";

initializeAllCollapsibles();
